webpackJsonp([33424470155352],{

/***/ 1874:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"NotificationMetadata","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"encounterId","type":{"kind":"SCALAR","name":"ID","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"id","type":{"kind":"SCALAR","name":"ID","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---object-notification-metadata-aedbf116bba68ac3aa8e.js